import { MEDIA_QUERIES } from '@student-coin/coinpaper-components';
import styled from 'styled-components';
import ArrowSVG from './arrowRight.svg';

export const Container = styled.a`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  border: ${({ theme }) => `1px solid ${theme.colors.title}`};
  padding: 8px;
  @media (${MEDIA_QUERIES.laptopL}) {
    border: none;
    padding: 0;
  }
`;

export const Column = styled.div<{ alignRight?: boolean }>`
  display: flex;
  justify-content: ${({ alignRight }) => alignRight && 'flex-end'};
  width: 100%;
`;

export const Text = styled.span<{ bold?: boolean }>`
  min-width: 40px;
  margin-left: 12px;
  font-weight: ${({ bold }) => bold && 600};
  @media (${MEDIA_QUERIES.laptopL}) {
    font-size: 13px;
  }
  @media (${MEDIA_QUERIES.desktopL}) {
    font-size: 14px;
  }
`;

export const RightText = styled.span`
  display: flex;
  align-items: center;
  font-size: 12px;
  font-weight: 400;
  white-space: nowrap;
`;

export const Arrow = styled(ArrowSVG)`
  margin-left: 8px;
`;
